module.exports = __webpack_public_path__ + "img/img-101.30599c47.png";